import { type EditRoleInputType } from '@shelflix/schemas/role/edit';
import { create } from 'zustand';

interface RoleFormStore {
  formData: Partial<EditRoleInputType>;
  setFormData: (data: Partial<EditRoleInputType>) => void;
  resetForm: () => void;
}

export const useRoleFormStore = create<RoleFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
